import { render, staticRenderFns } from "./distributionRelationshipList.vue?vue&type=template&id=3d5ac08d&scoped=true"
import script from "./distributionRelationshipList.vue?vue&type=script&lang=js"
export * from "./distributionRelationshipList.vue?vue&type=script&lang=js"
import style0 from "./distributionRelationshipList.vue?vue&type=style&index=0&id=3d5ac08d&prod&lang=less&scoped=true"
import style1 from "./distributionRelationshipList.vue?vue&type=style&index=1&id=3d5ac08d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ac08d",
  null
  
)

export default component.exports